import React, { useState } from 'react'
import Menu from '@mui/material/Menu'
import { trans } from '../../../../_providers/Translation'

//images
import menuIcon from '../../../../assets/img/icons/table-menu.png'
import editIcon from '../../../../assets/img/icons/edit.svg'
import deleteIcon from '../../../../assets/img/icons/delete.svg'
import activateIcon from '@/assets/img/contractors/icons/activate.svg'
import resetIcon from '@/assets/img/contractors/icons/reset.svg'
import deactivateIcon from '@/assets/img/contractors/icons/deactivate.svg'

function SubscriptionOptions(props) {

    const [table, setTable] = useState({
        options: null
    })

    const handleTableMenu = e => {

        setTable(table => {
            return {
                ...table,
                options: e.currentTarget
            }
        })
    }

    const handleCloseMenu = () => {
        setTable(table => {
            return {
                ...table,
                options: null
            }
        })
    }

    const handleEdit = id => {
        handleCloseMenu()

        props.handleEdit(id)
    }

    const handleDelete = id => {
        handleCloseMenu()

        props.handleDelete(id)
    }

    const handleActivate = id => {
        handleCloseMenu()

        props.handleActivate(id)
    }

    const handleDeactivate = id => {
        handleCloseMenu()

        props.handleDeactivate(id)
    }

    const handleRenew = id => {
        handleCloseMenu()

        props.handleRenew(id)
    }

    return (
        <>
            <img src={menuIcon} alt="menu" className="menu" onClick={handleTableMenu} />
            <Menu
                id={'menu-subs-' + props.id}
                anchorEl={table.options}
                keepMounted
                open={Boolean(table.options)}
                onClose={handleCloseMenu}
                style={{ zIndex: 13000 }}
            >

                {!props.data.is_activated
                    ?
                    <div className="menu-option" onClick={() => handleActivate(props.id)}>
                        <img src={activateIcon} alt="activate" />
                        {trans('buttons.activate')}
                    </div>
                    :
                    <div className="menu-option" onClick={() => handleRenew(props.id)}>
                        <img src={resetIcon} alt="reset" />
                        {trans('buttons.renew')}
                    </div>

                }

                {props.data.is_active
                    ?
                    <div className="menu-option" onClick={() => handleDeactivate(props.id)}>
                        <img src={deactivateIcon} alt="deactivate" />
                        {trans('buttons.deactivate')}
                    </div>
                    : ''
                }


                <div className="menu-option" onClick={() => handleEdit(props.id)}>
                    <img src={editIcon} alt="edit" />
                    {trans('buttons.edit')}
                </div>

                <div
                    className="menu-option"
                    onClick={() => handleDelete(props.id)}
                    style={{
                        color: "#EC5252"
                    }}
                >
                    <img src={deleteIcon} alt="delete" />
                    {trans('buttons.delete')}
                </div>
            </Menu>
        </>
    )
}

export default SubscriptionOptions
